module.exports = __webpack_public_path__ + "static/media/studentAttendance.9b77d7c8.svg";